<template>
  <section id="testimonials" class="py-24 bg-gray-50 text-center relative overflow-hidden">

    <div class="relative max-w-6xl mx-auto px-6">
      <h2 class="text-3xl font-bold text-gray-900">📢 O que você pode alcançar com Google Ads</h2>
      <p class="text-lg text-gray-600 mt-4">Veja como sua empresa pode crescer com campanhas bem estruturadas.</p>

      <!-- Grid Antes vs Depois -->
      <div class="grid md:grid-cols-2 gap-10 mt-12">
        <!-- Antes -->
        <div class="bg-white p-6 rounded-lg shadow-lg relative z-10 text-left">
          <h3 class="text-xl font-semibold text-red-600">Antes 😓</h3>
          <ul class="text-gray-600 mt-4 space-y-2">
            <li>❌ Baixo tráfego no site</li>
            <li>❌ Poucas vendas e leads</li>
            <li>❌ Sem previsibilidade no faturamento</li>
            <li>❌ Gastos com anúncios sem retorno</li>
          </ul>
        </div>

        <!-- Depois -->
        <div class="bg-white p-6 rounded-lg shadow-lg border-2 border-blue-600 relative z-10 text-left">
          <h3 class="text-xl font-semibold text-blue-600">Depois 🚀</h3>
          <ul class="text-gray-600 mt-4 space-y-2">
            <li>✅ Mais visitas qualificadas no site</li>
            <li>✅ Aumento de leads e vendas</li>
            <li>✅ Campanhas otimizadas para lucro</li>
            <li>✅ Retorno sobre investimento previsível</li>
          </ul>
        </div>
      </div>

      <!-- Mensagem "Em breve..." -->
      <div class="mt-16 text-gray-600 text-lg italic relative z-10">
        <p>📢 "Em breve, você verá aqui histórias reais de clientes satisfeitos!"</p>
      </div>
      
    </div>
  </section>
</template>
